import React, { useMemo } from "react";

// Context
import { useModalHistory } from "../../context/ModalHistoryProvider";

// Components
import PageStyle from "../../components/Styled/Page.style";
import Header from "../../components/Header/Header";
import MainTable from "../../components/MainTable/MainTable";
import SelectBase from "../../components/Inputs/SelectBase";

// Utils
import { inputWithStyle } from "../../HOC/inputWithStyle";
import { selectWithOptions } from "../../HOC/selectWithOptions";
import styled from "styled-components";
import { useEffect } from "react";
import api from "../../api/api";
import { SYSTEM_ACTIONS, useSystemContext } from "../../context/SystemProvider";
import { Outlet } from "react-router";

export default function Home() {
  const [{ modalHistory }] = useModalHistory();
  const [, dispatchSystemContext] = useSystemContext();

  const currentModal = useMemo(() => {
    return modalHistory[modalHistory.length - 1];
  }, [modalHistory]);

  useEffect(() => {
    (async () => {
      const vatResp = await api.getVAT();
      dispatchSystemContext({ type: SYSTEM_ACTIONS.SET_VAT, payload: vatResp?.vaT_GetFromValue });
    })();
  }, [dispatchSystemContext]);

  return (
    <PageStyle align="start">
      <BodyStyle>
        <Header />
        <MainTable />
        {/* <QueueStyle justifyContent="center">
          <SelectWithStyle
            options={loop(100, (i) => `Item ${++i}`)}
            showOptions={true}
            id="test"
            label="test"
            searchable
            selectable
            addable
          />
        </QueueStyle> */}
      </BodyStyle>
      {currentModal}
      <Outlet />
    </PageStyle>
  );
}

const SelectWithStyle = inputWithStyle(selectWithOptions(SelectBase));

const BodyStyle = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  align-content: start;
  width: 100%;
  height: 100vh;
`;
